"use client";

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';

const ComingSoonRedirect = () => {
  const router = useRouter();

  useEffect(() => {
    toast.info('This page will be live as soon as it gets launched!', {
      duration: 3000,
    });
    
    // Redirect after a short delay to allow toast to be visible
    const timer = setTimeout(() => {
      router.push('/');
    }, 500);

    return () => clearTimeout(timer);
  }, [router]);

  return null;
};

export default ComingSoonRedirect;

